"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { PortalRoutedPage } from './deskUi/PortalRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function PortalSurfaceClient(props: DeskSurfaceClientProps) {
  return (
    <MsgDeskSurfaceClient
      {...props}
      RoutedPage={PortalRoutedPage}
      Loading={MsgDeskLoading}
      loadInitialSubsOnMsgRoute={false}
    />
  )
}
